import Replacement from './replacement';
import BlockReplacer from '@intercom/embercom-composer/lib/block-replacer';
export default Replacement.extend().reopenClass({
  tryReplacement(block, mutationResult) {
    let blockReplacer = new BlockReplacer(block, this.replacement);
    blockReplacer.doReplacement(mutationResult);
  }
});